export function formatPurchaseAmountStringForMeta(amount: number): string {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}

export function normalizePurchaseAmountForMeta(amount: number): number {
  return Number(formatPurchaseAmountStringForMeta(amount));
}

export function normalizeCurrencyCodeForMeta(currency?: string | null): string {
  const code = String(currency ?? 'USD')
    .trim()
    .toUpperCase();
  return code || 'USD';
}
